import { Icon } from '@joor/design-system'
import styled from 'styled-components/macro'

import { forceFileDownload } from 'utils/requests'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;
`

const Row = styled.div`
  display: flex;
  padding: 8px 0 4px 10px;
  border-bottom: 1px solid var(--color-primary-200);
  font-size: 10px;
  background-attachment: fixed;

  &.header {
    background-color: var(--color-secondary-100);
    border: none;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid var(--color-secondary-600);
    font-size: 12px;
  }

  .col-01 {
    width: 30%;
  }

  .col-02 {
    width: 62%;
  }

  .col-03 {
    width: 8%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const FileErrorsTableTestIds = {
  container: 'file-errors-table',
} as const

export function FileErrorsTable({
  errors,
}: {
  errors: { error: string; filename: string; data?: Blob }[]
}) {
  const handleDownload = (filename: string, data: Blob) => {
    forceFileDownload(data, filename)
  }

  return (
    <Container data-testid={FileErrorsTableTestIds.container}>
      <Row className="header">
        <div className="col-01">File</div>
        <div className="col-02">Error</div>
        <div className="col-03" />
      </Row>
      {errors.map(({ error, filename, data }, index) => (
        <Row key={`${filename}-${index}`}>
          <div className="col-01 notranslate">{filename}</div>
          <div className="col-02">{error}</div>
          <div className="col-03">
            {data && (
              <Icon
                onClick={() => handleDownload(filename, data)}
                iconName="download"
              />
            )}
          </div>
        </Row>
      ))}
    </Container>
  )
}
